// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__WE3+G","title":"PrivacyPolicy_title__+wSqZ","contentTitle":"PrivacyPolicy_contentTitle__tX5E6","content":"PrivacyPolicy_content__623na"};